import(/* webpackMode: "eager" */ "/builds/southchip/official/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CookiePolicy"] */ "/builds/southchip/official/src/components/blocks/SiteConfig/CodeSnippet.tsx");
